import { render, staticRenderFns } from "./SettingsView.vue?vue&type=template&id=64225430&scoped=true&"
import script from "./SettingsView.vue?vue&type=script&lang=js&"
export * from "./SettingsView.vue?vue&type=script&lang=js&"
import style0 from "./SettingsView.vue?vue&type=style&index=0&id=64225430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64225430",
  null
  
)

export default component.exports